import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import LoadingSpinner from "./LoadingSpinner";

export default function ProtectedRoute({ children }) {
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log(
        "ProtectedRoute auth check:",
        currentUser ? `Authenticated: ${currentUser.email}` : "Unauthenticated"
      );
      setUser(currentUser);
      setChecking(false);
    });

    return () => {
      console.log("ProtectedRoute cleanup");
      unsubscribe();
    };
  }, []);

  if (checking) {
    return <LoadingSpinner />;
  }

  if (!user) {
    console.log("ProtectedRoute: Redirecting to /login");
    return <Navigate to="/login" replace />;
  }

  return children;
}